export default __webpack_public_path__ + "static/media/avatar_arrow_boy7.b3b420f1.mp3";